export default __webpack_public_path__ + "static/hfa_hoch_Logo_-ee7ed434e34196a416e33e399f20b014.png";